import React from 'react';

import BonoZone  from 'components/Tvendo/Sale/QuotaBPartner/ReglaParametro/BonoZone/List.js';

export default function () {
  return <BonoZone  />;
}